// Clean and normalize the Rights filter object for API requests
export function cleanRightsFilter(filter, rightRange, rightSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => {
                // Convert boolean values to strings for URL params
                if (['showFailedAssociations', 'hasDeal', 'hasCatalog'].includes(k)) {
                    return [k, v ? 'true' : 'false'];
                }
                return [k, v];
            })
            .filter(([k, v]) => {
                // Always include boolean fields even when false
                if (['showFailedAssociations', 'hasDeal', 'hasCatalog'].includes(k)) {
                    return true;
                }
                return v != null && v !== '';
            }),
    );

    if (rightRange) filtered.rightRange = rightRange;
    if (rightSort) filtered.rightSort = rightSort;

    return filtered;
}
